import { createGlobalStore } from 'hox';
import { useState } from 'react';

function useWhiteLabel() {
  const [whiteLabel, setWhiteLabel] = useState('');
  return { whiteLabel, setWhiteLabel };
}
export const [useWhiteLabelStore] = createGlobalStore(useWhiteLabel);
